
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "5c4f6e42-d2b8-48c3-b3f8-e645e0c8c947"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
